module.exports = __webpack_public_path__ + "img/1-18.6ee87c31.png";